<div class="cipafacil-drawer-content">
    <ng-content></ng-content>
</div>
